import { lazy, Suspense } from "react";
import { RouteObject } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";

/* -----------------------------------------------------------------
   Lazy‑loaded page components
   ----------------------------------------------------------------- */
const Home = lazy(() => import("../pages/home/page"));
const Login = lazy(() => import("../pages/login/page"));
const Dashboard = lazy(() => import("../pages/dashboard/page"));
/* Renamed to avoid clash with react‑router's <Routes> component */
const RoutesPage = lazy(() => import("../pages/routes/page"));
const Deliveries = lazy(() => import("../pages/deliveries/page"));
const ShiftPage = lazy(() => import("../pages/shift/page"));
const Statistics = lazy(() => import("../pages/statistics/page"));
const Settings = lazy(() => import("../pages/settings/page"));
const CompleteProfile = lazy(() => import("../pages/complete-profile/page"));
const PaymentSuccess = lazy(() => import("../pages/payment/success/page"));
const PaymentCancel = lazy(() => import("../pages/payment/cancel/page"));
const Privacy = lazy(() => import("../pages/privacy/page"));
const DeleteAccount = lazy(() => import("../pages/delete-account/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

/* Optional simple fallback for all lazy components */
const LoadingFallback = () => (
  <div>Loading…</div>
);

/* -----------------------------------------------------------------
   Route configuration
   ----------------------------------------------------------------- */
const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "/login",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Login />
      </Suspense>
    ),
  },
  {
    path: "/complete-profile",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <CompleteProfile />
      </Suspense>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Suspense fallback={<LoadingFallback />}>
          <Dashboard />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: "/routes",
    element: (
      <ProtectedRoute>
        <Suspense fallback={<LoadingFallback />}>
          <RoutesPage />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: "/deliveries",
    element: (
      <ProtectedRoute>
        <Suspense fallback={<LoadingFallback />}>
          <Deliveries />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: "/shift",
    element: (
      <ProtectedRoute>
        <Suspense fallback={<LoadingFallback />}>
          <ShiftPage />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: "/statistics",
    element: (
      <ProtectedRoute>
        <Suspense fallback={<LoadingFallback />}>
          <Statistics />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings",
    element: (
      <ProtectedRoute>
        <Suspense fallback={<LoadingFallback />}>
          <Settings />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: "/payment/success",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <PaymentSuccess />
      </Suspense>
    ),
  },
  {
    path: "/payment/cancel",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <PaymentCancel />
      </Suspense>
    ),
  },
  {
    path: "/privacidade",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Privacy />
      </Suspense>
    ),
  },
  {
    path: "/privacy",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Privacy />
      </Suspense>
    ),
  },
  {
    path: "/excluir-conta",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <DeleteAccount />
      </Suspense>
    ),
  },
  {
    path: "/delete-account",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <DeleteAccount />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <NotFound />
      </Suspense>
    ),
  },
];

export default routes;
